import {
  CardsLkAction,
  CardsLkAdapted,
  CardsLkElement,
  CardsLkItem,
  CardsLkProperty,
  CardsLkResponse,
  CardsLkSection,
  CardsLkSectionAdapted,
  CardsLkYmEventProperty,
} from '../../../contracts/CardsLk'
import { removeTrailingSlash, stripBaseUrl } from '../../../helpers/string'

const ACTIONS_BY_LABEL: Record<string, CardsLkAction> = {
  'открыть блиц': 'openBlitz',
  'перейти по ссылке': 'navigate',
}

const propertyValue = (property?: CardsLkProperty): string | null =>
  property?.values?.[0]?.value || null

const resolveMediaUrl = (raw: string | null, mediaBase: string) =>
  raw ? removeTrailingSlash(mediaBase) + stripBaseUrl(raw) : null

const ymTarget = (property?: CardsLkYmEventProperty): string | null =>
  propertyValue(property?.values?.[0]?.value?.properties?.ymTarget)

const mapAction = (raw: string | null): CardsLkAction | null => {
  if (!raw) {
    return null
  }
  const label = raw.trim().replace(/\s+/g, ' ').toLowerCase().replace(/ё/g, 'е')
  return ACTIONS_BY_LABEL[label] || null
}

const adaptElements = (
  elements: CardsLkElement[],
  mediaBase: string
): CardsLkItem[] =>
  elements
    .filter((element) => Boolean(propertyValue(element.properties.title)))
    .sort((a, b) => a.sort - b.sort)
    .map((element) => ({
      action: mapAction(propertyValue(element.properties.action)),
      image: resolveMediaUrl(
        propertyValue(element.properties.image),
        mediaBase
      ),
      subtitle: propertyValue(element.properties.subtitle),
      title: propertyValue(element.properties.title) || '',
      url: propertyValue(element.properties.url),
      video: resolveMediaUrl(
        propertyValue(element.properties.video),
        mediaBase
      ),
      ymTarget: ymTarget(element.properties.ymEvent),
    }))

const adaptSection = (
  section: CardsLkSection,
  mediaBase: string
): CardsLkSectionAdapted => ({
  code: section.code || null,
  id: section.id,
  items: [
    ...adaptElements(section.elements || [], mediaBase),
    ...adaptElements(
      (section.sections || []).flatMap(
        (subsection) => subsection.elements || []
      ),
      mediaBase
    ),
  ],
  name: section.name,
  sort: section.sort,
})

export const cardsLkAdapter = (
  response: CardsLkResponse,
  mediaBase: string
): CardsLkAdapted => ({
  sections: (response.data?.sections || [])
    .slice()
    .sort((a, b) => a.sort - b.sort)
    .map((section) => adaptSection(section, mediaBase)),
})
